export const GET_JSON = 'GET_JSON';
export const DNA_STEP = 'DNA_STEP';
export const CLEAR_JSON = 'CLEAR_JSON';
export const GET_ANNOUNCEMENT_JSON = 'GET_ANNOUNCEMENT_JSON';
